// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.report-actions[data-v-25c22cdd] {\n    background-color: #f5f5f5;\n    border-bottom: 1px solid #e0e0e0;\n}\n.report-content[data-v-25c22cdd] {\n    min-height: 200px;\n    border: 1px solid #e0e0e0;\n}\n.docx-preview-wrapper[data-v-25c22cdd] {\n    background-color: #fff;\n    padding: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
